"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var addFitToContainerStyle = function (_a) {
    var shouldFitToContainer = _a.shouldFitToContainer;
    return (shouldFitToContainer === false
        ? { style: { width: 'fit-content' } }
        : undefined);
};
exports.Wrapper = styled_components_1.default.div.attrs(addFitToContainerStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 4px;\n  box-shadow:\n    0 18px 36px 0 rgba(34, 34, 43, 0.08),\n    0 8px 24px 0 rgba(34, 34, 43, 0.16),\n    0 6px 16px 0 rgba(34, 34, 43, 0.08);\n  overflow: auto;\n\n  /* tablet portrait: */\n  @media only screen and (min-width: ", ")\n    and (max-width: calc(", " - 1px)) {\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n  }\n\n  /* mobile: */\n  @media only screen and (max-width: calc(", " - 1px)) {\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n  }\n"], ["\n  background: ", ";\n  border-radius: 4px;\n  box-shadow:\n    0 18px 36px 0 rgba(34, 34, 43, 0.08),\n    0 8px 24px 0 rgba(34, 34, 43, 0.16),\n    0 6px 16px 0 rgba(34, 34, 43, 0.08);\n  overflow: auto;\n\n  /* tablet portrait: */\n  @media only screen and (min-width: ", ")\n    and (max-width: calc(", " - 1px)) {\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n  }\n\n  /* mobile: */\n  @media only screen and (max-width: calc(", " - 1px)) {\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white.s100;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoint.tablet;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoint.desktop;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoint.tablet;
});
exports.Wrapper.displayName = 'PanelWrapper';
var templateObject_1;
